export default "__VITE_ASSET__DvsBnC47__"